const BASE_URL = `https://react-shop-4493e-default-rtdb.firebaseio.com/`;

export default BASE_URL;
